var pug = require("!../../../../../../pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cmain-header\u003E\u003C\u002Fmain-header\u003E\u003Cdiv class=\"row main-content no-padding-xs flex-horizontal-centered\" ui-view=\"\" autoscroll=\"true\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;